import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { EmailReservationService } from '../../core/services/email-reservation.service';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-email-settings',
    imports: [FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-edit"></i> 文面確認メール送信先</span>
    </div>
    <div class="card-body">
      <!-- 旧版 email-settings.html:10-12 の card-body 先頭 <flash-message> 相当 -->
      <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
      @if (loading) {
        <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
      }
      @if (!loading) {
        <form novalidate name="emailContentForm" #emailContentForm="ngForm" (ngSubmit)="save()">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">メールアドレス1</label>
                  <input type="email" class="form-control" [(ngModel)]="items[0].email" name="email0" email [pattern]="asciiPattern">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">メールアドレス2</label>
                  <input type="email" class="form-control" [(ngModel)]="items[1].email" name="email1" email [pattern]="asciiPattern">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">メールアドレス3</label>
                  <input type="email" class="form-control" [(ngModel)]="items[2].email" name="email2" email [pattern]="asciiPattern">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">メールアドレス4</label>
                  <input type="email" class="form-control" [(ngModel)]="items[3].email" name="email3" email [pattern]="asciiPattern">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12 text-right">
                  <button type="submit" class="btn btn-success" [disabled]="saving || emailContentForm.invalid">
                    <i class="fa s-icon-save fa-fw"></i>&nbsp;保存
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  </div>
</div>
  `
})
export class EmailSettingsComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private emailReservationService = inject(EmailReservationService);
  private flash = inject(FlashService);

  items: { email: string }[] = [{email:''},{email:''},{email:''},{email:''}];
  loading = true;
  saving = false;
  readonly asciiPattern = /^[\x01-\x7E]+$/;

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('設定', 'settings', true);
    await this.load();
  }

  private async load(): Promise<void> {
    this.loading = true;
    try {
      const data: any = await this.emailReservationService.getEmailSettingsHQAddress();
      const arr: any[] = Array.isArray(data) ? data : [];
      for (let i = 0; i < 4; i++) {
        this.items[i] = { email: arr[i]?.email ?? '' };
      }
    } finally {
      this.loading = false;
    }
  }

  async save(): Promise<void> {
    this.saving = true;
    try {
      const json = this.items.filter(v => v.email);
      await this.emailReservationService.upsertEmailSettingsHQAddress(json);
      // 旧版 email-settings.js:21-24: Flash 後に state reload
      this.flash.create('success', '文面確認メール送信先を更新しました');
      await this.load();
    } finally {
      this.saving = false;
    }
  }
}
